import React, { useRef } from 'react';
import classnames from 'classnames';
import get from 'lodash/get';
import { useDeviationViewContext } from '../../Context';
import StageContainer from '../_partials/StageContainer';
import DeviationFullView from '../../DeviationViews/Full';
import DuperbrowsePaddles from '../../Duperbrowse/DuperbrowsePaddles';
import StageBackground from '../../DeviationBackground/StageBackground';
import { useMeasuredStage } from '../hooks/useMeasuredStage';
import { useDuperbrowseViewType } from '../../Duperbrowse/DuperbrowseViewContext';
import s from './DesktopArtStage.scss';
export var DesktopArtStage = function (_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner, className = _a.className, isZoomed = _a.isZoomed, withDuperbrowsePaddles = _a.withDuperbrowsePaddles, _b = _a.onEnterZoomMode, onEnterZoomMode = _b === void 0 ? function () { return null; } : _b, _c = _a.onExitZoomMode, onExitZoomMode = _c === void 0 ? function () { return null; } : _c;
    var isFullscreen = useDeviationViewContext().isFullscreen;
    var isLightbox = useDuperbrowseViewType().isLightbox;
    var ref = useRef(null);
    var _d = useMeasuredStage(ref, !isFullscreen), contentSize = _d.contentSize, containerSize = _d.containerSize;
    return (React.createElement(StageContainer, { className: classnames(s['root'], className, isFullscreen && s['fullscreen'], isLightbox && s['lightbox']) },
        React.createElement("div", { className: s['content'], ref: ref },
            React.createElement(StageBackground, { deviation: deviation, height: get(containerSize, 'height'), width: get(containerSize, 'width') }),
            React.createElement(DeviationFullView, { deviation: deviation, height: get(contentSize, 'height'), width: get(contentSize, 'width'), isZoomed: isZoomed, onEnterZoomMode: onEnterZoomMode, onExitZoomMode: onExitZoomMode }),
            withDuperbrowsePaddles && !isLightbox && (React.createElement(DuperbrowsePaddles, { className: s['duperbrowse'] })))));
};
DesktopArtStage.displayName = 'DesktopArtStage';
export default DesktopArtStage;
//# sourceMappingURL=DesktopArtStage.js.map